module.exports = __webpack_public_path__ + "static/img/bg-1.1aafef84.webp";